import { render, staticRenderFns } from "./GestionCategories.vue?vue&type=template&id=5ecc5c2d&scoped=true&"
import script from "./GestionCategories.vue?vue&type=script&lang=js&"
export * from "./GestionCategories.vue?vue&type=script&lang=js&"
import style0 from "./GestionCategories.vue?vue&type=style&index=0&id=5ecc5c2d&lang=scss&scoped=true&"
import style1 from "./GestionCategories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc5c2d",
  null
  
)

export default component.exports